import { isDerivedWorkType, WorkType } from '@warehouse/title-shared/core';
import { labelFromWorkType } from './worktype';

// Title type chip: line 1 is the work type, line 2 its work type detail.
// Edits and Manifestations without a detail keep their abstraction type on line 2; a detail that only repeats the type is not shown.
export function titleTypeChipLines({
	workType,
	l1WorkType,
	detailLabel,
}: {
	workType: WorkType;
	l1WorkType: WorkType;
	detailLabel: string | undefined;
}): { line1: string; line2: string | undefined } {
	const line1 = labelFromWorkType(workType);

	if (detailLabel && detailLabel !== line1) return { line1, line2: detailLabel };
	if (isDerivedWorkType(workType)) return { line1, line2: labelFromWorkType(l1WorkType) };
	return { line1, line2: undefined };
}
